import { Component } from '@angular/core';

@Component({
  selector: 'app-student-fees',
  imports: [],
  templateUrl: './student-fees.component.html',
  styleUrl: './student-fees.component.scss'
})
export class StudentFeesComponent {

}
